<template>
    <div>
        <form @submit.prevent="submit" id="forgotPasswordForm" novalidate="novalidate" v-if="!sent">
            <span class="p-mb-3 p-field p-col-12 p-d-block p-d-no-padding">
                <label for="email" v-t="'label.email'"></label>
                <InputText
                    id="email"
                    v-model="address"
                    type="email"
                    aria-autocomplete="none"
                    autocomplete="off"
                    :class="{ invalid: errors.email.length }"
                />
            </span>
            <div class="input-error-container p-mb-5">
                <small v-if="errors.email.length" class="input-error" v-t="'errors.email.' + errors.email" />
            </div>
            <Button
                type="submit"
                class="p-button"
                :label="$t('button.submit')"
            ></Button>
        </form>
        <p v-if="sent" class="sent" v-t="'sent'"></p>
        <p>
            <router-link
                :to="{ name: 'login' }"
                class="forgot-password"
                v-t="'link'"
            />
        </p>
    </div>
</template>

<script>
    import Button from 'primevue/button';
    import InputText from 'primevue/inputtext';
    import isValidEmail from "myra-ui-common/utils/isValidEmail";

    export default {
        name       : 'ForgotPassword',
        components : { Button, InputText },
        props      : {
            sent : {
                type    : Boolean,
                default : false,
            },
        },
        data() {
            return {
                address : '',
                errors  : {
                    email : '',
                }
            };
        },
        watch : {
            address() {
                this.errors.email = '';
            },
        },
        methods : {
            isFormValid() {
                let isValid = true;
                if (this.address.length < 1) {
                    this.errors.email = 'empty';
                    isValid = false;
                } else if (!isValidEmail(this.address)) {
                    this.errors.email = 'invalidEmail';
                    isValid = false;
                }
                return isValid;
            },
            submit() {
                if (!this.isFormValid()) {
                    return;
                }
                this.$emit('submit', 'requestNewPassword', this.address);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .sent {
        color: #2bb673;
        font-size: 18px;
    }
</style>

<i18n src="myra-ui-common/i18n/common.json" />
<i18n src="./i18n.json" />